import React from "react";
import {
  Cloud,
  FileText,
  Video,
  FolderLock,
  Share2,
  Mail,
} from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { GlowOrb, Overline } from "../components/SectionDecor";

const icons = [Cloud, FileText, Video, FolderLock, Share2, Mail];

const Tools = () => {
  const { t } = useLanguage();
  return (
    <div data-testid="page-tools" className="relative">
      <GlowOrb color="#00d4ff" size={400} opacity={0.1} className="top-10 -right-20" />

      <section className="relative mx-auto max-w-7xl px-6 lg:px-10 pt-24 pb-12">
        <div className="max-w-3xl">
          <Overline>{t.tools.overline}</Overline>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
            {t.tools.title}
          </h1>
          <p className="mt-5 text-lg text-zinc-400">{t.tools.subtitle}</p>
        </div>
      </section>

      <section className="relative mx-auto max-w-7xl px-6 lg:px-10 pb-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.tools.items.map((item, idx) => {
            const Icon = icons[idx % icons.length];
            return (
              <div
                key={item.name}
                data-testid={`tool-card-${idx}`}
                className="smk-card rounded-2xl p-7 group"
              >
                <div className="flex items-center justify-between">
                  <div className="h-11 w-11 rounded-xl bg-white/5 border border-white/10 group-hover:border-[#00d4ff]/40 flex items-center justify-center transition">
                    <Icon size={18} className="text-[#00d4ff]" />
                  </div>
                  <span className="font-mono text-[10px] text-zinc-500">
                    0{idx + 1}
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-semibold">{item.name}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 smk-card rounded-2xl p-8 lg:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-8">
            <Overline>Open Source & Souverain</Overline>
            <h3 className="mt-3 text-2xl sm:text-3xl font-semibold tracking-tight">
              Reprenez le contrôle de vos données.
            </h3>
            <p className="mt-3 text-zinc-400">
              Nous déployons ces solutions sur votre infrastructure (On-Premise ou Cloud privé) avec une intégration complète à votre annuaire (LDAP / Active Directory) et à vos politiques de sécurité.
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <div className="font-mono text-xs text-zinc-500 space-y-1">
              <div><span className="text-[#00d4ff]">→</span> Hébergement souverain</div>
              <div><span className="text-[#00d4ff]">→</span> Chiffrement de bout en bout</div>
              <div><span className="text-[#00d4ff]">→</span> Conformité RGPD</div>
              <div><span className="text-[#00d4ff]">→</span> Intégration LDAP / AD</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tools;
